import {
  AfterViewInit,
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';

export enum PlayerState {
  stoped = 'stoped',
  playing = 'playing',
  paused = 'paused'
}

@Directive({
    selector: '[livMediaControl]',
    standalone: false
})
export class MediaControlDirective implements OnDestroy, AfterViewInit {
  @Input('livMediaControl') mediaElement: HTMLMediaElement | null = null;
  @Input() volume = 0.5;

  @Output() playEvent = new EventEmitter<void>();
  @Output() pauseEvent = new EventEmitter<void>();
  @Output() endedEvent = new EventEmitter<void>();

  @Output() statusChange = new EventEmitter<PlayerState>();

  private isPlaying = PlayerState.stoped;
  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    queueMicrotask(() => {
      this.configureMediaElement();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.mediaElement?.src) {
      URL.revokeObjectURL(this.mediaElement.src);
    }
  }

  @HostListener('play')
  onPlay() {
    this.isPlaying = PlayerState.playing;
    this.playEvent.emit();
    this.statusChange.emit(this.isPlaying);
  }

  @HostListener('pause')
  onPause() {
    this.isPlaying = PlayerState.paused;
    this.pauseEvent.emit();
    this.statusChange.emit(this.isPlaying);
  }

  @HostListener('ended')
  onEnded() {
    this.isPlaying = PlayerState.stoped;
    this.endedEvent.emit();
    this.statusChange.emit(this.isPlaying);
  }

  @HostListener('click')
  onClick() {
    if (this.mediaElement) {
      if (this.isPlaying === PlayerState.playing) {
        this.mediaElement.pause();
      } else {
        this.mediaElement.play();
      }
      this.isPlaying =
        this.isPlaying === PlayerState.playing
          ? PlayerState.paused
          : PlayerState.playing;
      this.statusChange.emit(this.isPlaying);
    }
  }

  private handlePageChange() {
    if (this.isPlaying === PlayerState.playing) {
      this.mediaElement?.pause();
      this.isPlaying = PlayerState.paused;
      this.pauseEvent.emit();
      this.statusChange.emit(this.isPlaying);
    }
  }

  private configureMediaElement() {
    if (this.mediaElement) {
      if (this.volume !== null) {
        this.mediaElement.volume = this.volume;
      }

      this.mediaElement.preload = 'metadata';
    }
  }
}
